import * as E from 'fp-ts/Either';
import { config } from '../config';
import { stringify } from 'qs';
import { ErrorResponse } from './common';

export type LicenseLogEntry = {
  _id: string;
  date: string;
  meta: {
    apiKey: string;
    app: string;
    ip: string;
  };
  matchData: Record<string, string>;
  returnData: Record<string, any>;
  extraFields?: Record<string, any>;
  error?: string; // only on failure logs
};

export type LicenseStatEntry = {
  date: string;
  app: string;
  hits: number;
};

export type LicenseLogsResponse = {
  data: LicenseLogEntry[];
  next?: string;
  prev?: string;
};

export const licenseStats = async (
  token: string,
  granularity?: string | null,
  dateRange?: { from: string; to: string } | null,
  app?: string | null
): Promise<E.Either<ErrorResponse, LicenseStatEntry[]>> => {
  let queryObj: Record<string, any> = dateRange ? dateRange : {};
  if (granularity) {
    queryObj = { ...queryObj, granularity };
  }
  if (app) {
    queryObj = { ...queryObj, filter: { 'meta.app': app } };
  }
  const query = stringify(queryObj);

  const response = await fetch(
    `${config.apiUrl}/cms/v1/logs/licenses?${query}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const data = await response.json();

  return response.ok ? E.right(data) : E.left(data);
};

export const pageLogs =
  (url: string) =>
  async (
    token: string,
    dateRange?: { from: string; to: string } | null,
    app?: string | null,
    cursor?: string | null
  ): Promise<E.Either<ErrorResponse, LicenseLogsResponse>> => {
    let queryObj = dateRange ? dateRange : {};
    if (cursor) {
      queryObj = { ...queryObj, next: cursor };
    }
    if (app) {
      queryObj = { ...queryObj, filter: { 'meta.app': app } };
    }
    const query = stringify(queryObj);

    const response = await fetch(`${url}?${query}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();

    return response.ok ? E.right(data) : E.left(data);
  };

export const licenseLogs = pageLogs(
  `${config.apiUrl}/cms/v1/logs/licenses/entries`
);

export const licenseFailureLogs = pageLogs(
  `${config.apiUrl}/cms/v1/logs/license-failures`
);
